import { useParams } from 'react-router-dom';
import { WorkspacesComponent } from '@umd-dit/workspaces-component-react';
import { useAuth } from '../../context/AuthContext';

export default function WorkspaceManagementPage() {
  const { orgId } = useParams<{ orgId: string }>();
  const { isAdmin, selectedWorkspaceId } = useAuth();
  
  // For workspace management, we need a selected workspace
  // If user is global admin, they can admin any workspace; otherwise they need workspace-specific permissions
  const viewType = isAdmin ? "workspace-admin" : "user";
  
  return (
    <WorkspacesComponent
      appId="legislative-review"
      viewType={viewType}
      workspacesApiUrl={import.meta.env.VITE_WORKSPACES_API_URL}
      selectedOrganizationId={orgId}
      selectedWorkspaceId={selectedWorkspaceId || undefined}
      debug={import.meta.env.VITE_WORKSPACES_DEBUG_LOGGING === 'true'}
    />
  );
}